




































































































































import Vue from "vue";
import ToolMixin from "@/mixins/ToolMixin";
import DamageDialog from "@/components/projects/DamageDialog.vue";
import NotPermitted from "@/views/NotPermitted.vue";
import { DamageTable_damageTable, Project_project } from "@/api-types";

import DAMAGE_TABLE from "@/graphql/projects/DamageTable.gql";
import DAMAGE_DELETE from "@/graphql/projects/DamageDelete.gql";

export default Vue.extend({
  name: "DamageTable",
  mixins: [ToolMixin],
  props: { project: Object as () => Project_project },
  components: { DamageDialog, NotPermitted },
  apollo: {
    damageTable: {
      query: DAMAGE_TABLE,
      variables() {
        return { id: this.project.damageTable!.id };
      },
      result() {
        document.title = `Hydromapper - Schadenstabelle vom Projekt '${
          this.project.name
        }'`;
        this.$store.commit(
          "setToolbarTitle",
          `${this.project.name}: Schadenstabelle`
        );
      }
    }
  },
  data: () => ({
    damageTable: null as DamageTable_damageTable | null,
    editDamage: "",
    removeDamage: ""
  }),
  computed: {
    headers() {
      const items = [
        {
          text: "Nr.",
          value: "node.number",
          sortable: true
        },
        {
          text: "3D Viewer",
          value: "node.perspective.name",
          sortable: true
        },
        {
          text: "Schadensskizze",
          value: "node.draft",
          sortable: true
        },
        {
          text: "Schadenverdachtsplan",
          value: "node.suspicionPlan",
          sortable: true
        },
        {
          text: "Schadensübersicht",
          value: "node.overviewPlan",
          sortable: true
        }
      ];
      if (
        this.$auth.check("ROLE_PROJECTMANAGER") ||
        this.$auth.check("ROLE_ADMIN")
      ) {
        items.push({
          text: "Aktionen",
          value: "action",
          sortable: false
        });
      }

      return items;
    }
  },
  methods: {
    deleteDamage() {
      this.$apollo
        .mutate({
          mutation: DAMAGE_DELETE,
          variables: { id: this.removeDamage }
        })
        .then(() => {
          this.removeDamage = "";
          this.$apollo.queries.damageTable.refetch();
        });
    }
  }
});
